import React, { useRef, useState } from "react";
import { PaymentMethodCardProps } from "./PaymentMethodsCardInterface";
import ConnectButton from "./PaymentMethodsButtons/ConnectButton";
import UpdateButton from "./PaymentMethodsButtons/UpdateButton";
import Loader from "../../../common/Loader";
import { getPaymentMethodConfiguration } from "../../../../services/payment/payment";
import { PaymentMethodStatus } from "../PaymentMethodsInterface";
import { useAuth } from "../../../../context/AuthContext";
import { dictionary } from "../../../../utils/dictionary";

const PaymentMethodCard: React.FC<PaymentMethodCardProps> = ({
  name,
  logoSrc,
  isActive,
  isConnected,
  onToggle,
  onConnect,
  onUpdate,
  notConfigured,
}) => {
  const { language } = useAuth();
  const [loading, setLoading] = useState(true);
  const isActiveCorrect = useRef(isActive);

  const handleToggle = (e: React.ChangeEvent<HTMLInputElement>) => {
    onToggle();
    if (notConfigured) {
      return;
    }
    setLoading(false);
    const isChecked = e.target.checked;
    isActiveCorrect.current = isChecked;
    setTimeout(() => {
      setLoading(true);
    }, 500);
  };

  return (
    <div className="w-72 p-4 bg-white rounded-[10px] shadow-[4px_4px_15px_0px_rgba(0,0,0,0.2)] flex flex-col justify-between gap-4 p-6">
      {/* Encabezado con logo y estado */}
      <div className="flex items-center justify-between w-full">
        {/* Estado visual */}
        <div
          className={`px-3 py-1 text-sm font-semibold rounded-lg ${
            isActiveCorrect.current
              ? "bg-green-200 text-green-700"
              : "bg-red-200 text-red-700"
          }`}
        >
          {isActiveCorrect.current ? dictionary["active"][language] : dictionary["inactive"][language]}
        </div>
      </div>
      <div className="flex flex-col">{logoSrc}</div>

      {/* Toggle */}
      {/* {loading ? (
        <div className="flex items-center">
          <span
            className={`mr-2 text-sm ${
              isActiveCorrect.current ? "font-thin text-gray-400" : "font-bold"
            }`}
          >
            {dictionary["off"][language]}
          </span>
          <label className="relative inline-flex items-center cursor-pointer">
            <input
              type="checkbox"
              checked={isActiveCorrect.current}
              onChange={(e) => handleToggle(e)}
              className="sr-only peer"
            />
            <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-2 peer-focus:ring-blue-300 rounded-full peer dark:bg-gray-300 peer-checked:bg-blue-600 transition-colors" />
            <span className="absolute left-1 top-1 w-4 h-4 bg-white rounded-full peer-checked:translate-x-5 transition-transform" />
            <span
              className={`ml-2 text-sm ${
                isActiveCorrect.current
                  ? "font-bold"
                  : "font-thin text-gray-400"
              }`}
            >
              {dictionary["on"][language]}
            </span>
          </label>
        </div>
      ) : (
        <div className="flex items-center justify-center">
          <Loader size={24} />
        </div>
      )} */}

      {/* Botón de conexión dinámico */}

      {isConnected ? (
        <UpdateButton onClick={onUpdate} />
      ) : (
        <ConnectButton onClick={onConnect} />
      )}
    </div>
  );
};

export default PaymentMethodCard;
